/* eslint-disable import/prefer-default-export */

export const TOUR_CHANGED = 'TOUR_CHANGED';
export const TOUR_DATES_CHANGED = 'TOUR_DATES_CHANGED';

export const TOUR_DETAILS_MENU_ITEM = 'TOUR_DETAILS_MENU_ITEM';
export const EVENTS_MENU_ITEM = 'EVENTS_MENU_ITEM';
export const ANNOUNCE_AND_ON_SALE_ITEM = 'ANNOUNCE_AND_ON_SALE_ITEM';
export const EVENT_IMAGES_MENU_ITEM = 'EVENT_IMAGES_MENU_ITEM';

export const ADD_EVENTS_MANUAL = 'ADD_EVENTS_MANUAL';
export const ADD_EVENTS_CSV = 'ADD_EVENTS_CSV';
